import React, { Component } from 'react';
import PropTypes from 'prop-types';
import utils from '@utils';
import { isEqual } from 'lodash';

class PingListItem extends Component {
	shouldComponentUpdate({ item, timeZoneId }) {
		const lastProps = this.props;
		return (
			!isEqual(item, lastProps.item)
			|| !isEqual(timeZoneId, lastProps.timeZoneId)
		);
	}

	render() {
		const { item, timeZoneId, onClick } = this.props;

		return (
			<div
				key={`job_point_button_${item.id}`}
				className="point-selector-btn"
				onClick={() => onClick([
					{ property : 'locationDetails.mapCenter', value : item.location },
					{ property : 'locationDetails.highlightedMarker', value : item.id },
				])}
				role="button"
				tabIndex={0}
				onKeyPress={null}
			>
				<div>
					<span className={`map-marker ${item.type}-marker margin-right-20`} />
				</div>
				<div>
					<Choose>
						<When condition={item.type === 'job'}>
							<div>
								<span className="font-bold margin-right-5">Job Location</span>
							</div>
							<div>{ item.name }</div>
						</When>
						<Otherwise>
							<div>
								<span className="font-bold margin-right-5">{ item.name }</span>
								<span className="font-light margin-right-5">on</span>
								<span>{ utils.parseUTCDateToTimeZone(item.dateTime, timeZoneId).format('MM/DD/YYYY') }</span>
								<span className="font-light margin-left-5 margin-right-5">at</span>
								<span>{ utils.parseUTCDateToTimeZone(item.dateTime, timeZoneId).format('h:mm a') }</span>
							</div>
							<div>
								<span className="font-bold margin-right-5">Distance</span>
								<span className="font-light margin-right-5">of</span>
								<span>{ item.distance.toFixed(2) }</span>
								<span className="font-light"> miles</span>
							</div>
						</Otherwise>
					</Choose>
				</div>
			</div>
		);
	}
}

PingListItem.propTypes = {
	item       : PropTypes.object,
	onClick    : PropTypes.func.isRequired,
	timeZoneId : PropTypes.string,
};

PingListItem.defaultProps = {
	item       : {},
	timeZoneId : '',
};

export default PingListItem;
